<script>
    import API from '../../../../api';
    import {
        RESERVATION_TECHRESERVATION_CHANGE_DEPOSIT_ENDPOINT,
        RESERVATION_TECHRESERVATION_DELETE_DEPOSIT_ENDPOINT,
    } from '../../../../endpoints';
    import TechInfoTable from './tech-info-table.vue';
    import ActionsHeaderRendererAddItem from './actions-header-renderer-add-item.vue';
    import ActionsCellRendererRemoveItem from './actions-cell-renderer-delete-item.vue';
    import { toAmountDisplay } from '../../../../utils/numbers';

    export default {
        extends: TechInfoTable,
        components: {
            actionsCellRendererRemoveItem: ActionsCellRendererRemoveItem,
            actionsHeaderRendererAddItem: ActionsHeaderRendererAddItem,
        },
        data() {
            return {
                module: 'deposit',
                columnDefs: [
                    {
                        headerName: '',
                        maxWidth: 60,
                        flex: 1,
                        sortable: false,
                        resizable: false,
                        cellClass: 'tech-info-remove-item',
                        headerComponent: 'actionsHeaderRendererAddItem',
                        headerComponentParams: {
                            addItem: () => {
                                this.addItem();
                            },
                            conditional: false,
                        },
                        cellRenderer: 'actionsCellRendererRemoveItem',
                        cellRendererParams: {
                            deleteItem: id => {
                                this.deleteItem(id, RESERVATION_TECHRESERVATION_DELETE_DEPOSIT_ENDPOINT);
                            },
                        },
                    },
                    {
                        headerName: 'Deposits',
                        sortable: false,
                        field: 'title',
                        flex: 1,
                        type: 'editableColumn',
                        editable: true,
                        cellClass: 'lx-editable-cell text-primary',
                        valueSetter: ({ node, data, newValue }) => {
                            if (data.title != newValue) {
                                data.title = newValue;
                                this.changeDepositTitle(data.id, newValue);
                            }
                            return newValue
                        },
                        resizable: false,
                        autoWidthExclude: true,
                        minWidth: 200,
                    },
                    {
                        type: 'editableColumn',
                        headerName: 'Amount',
                        field: 'total_net',
                        cellRenderer: ({ data, value }) =>
                            toAmountDisplay({
                                amount: value,
                                currency: this.userCurrencySymbol,
                            }),
                        sortable: false,
                        cellEditorParams: { isDecimal: true, select: true },
                        editable: true,
                        cellClass: 'lx-editable-cell text-primary ag-right-aligned-cell',
                        valueSetter: ({ node, data, newValue }) => {
                            data.total_net = newValue;
                            this.changeDepositValue(data.id, newValue);
                            return newValue
                        },
                        valueParser: (value) => {
                            return value.total_net;
                        },
                        resizable: false,
                        headerClass: 'ag-right-aligned-header',
                    },
                ],
            };
        },
        methods: {
            async changeDepositValue(id, value) {
                this.busy = true;
                try {
                    await API.patch(RESERVATION_TECHRESERVATION_CHANGE_DEPOSIT_ENDPOINT(this.reservationId), {
                        id: id,
                        value: value,
                    });
                    await this.refreshReservationInvoice(this.metaReservationId);
                } catch (e) {
                    this.errorToast({ text: `Could not change deposit value.` });
                } finally {
                    this.busy = false;
                }
            },
            async changeDepositTitle(id, value) {
                this.busy = true;
                try {
                    await API.patch(RESERVATION_TECHRESERVATION_CHANGE_DEPOSIT_ENDPOINT(this.reservationId), {
                        id: id,
                        title: value,
                    });
                    await this.refreshReservationInvoice(this.metaReservationId);
                } catch (e) {
                    this.errorToast({ text: `Could not change deposit value.` });
                } finally {
                    this.busy = false;
                }
            },
        },
    };
</script>
